import PropertyComponent from "components/PropertyComponent";

export default function NewProperty() {
  return (
    <div>
      <PropertyComponent title="Add Listing" />
    </div>
  );
}
